const ADDRESS_FIELDS = [
  'street',
  'city',
  'state',
  'zip',
  'street_name',
  'street_number',
  'street_type',
  'street_affix',
  'street_physical'
];

/**
 * Returns root-level current address details when current_address is true.
 * @param {object} report
 * @returns {object|null}
 */
const getCurrentRootAddress = report => {
  if (!report || report.current_address !== true) {
    return null;
  }

  return ADDRESS_FIELDS.reduce((currentAddress, field) => {
    currentAddress[field] = report[field] ?? null;
    return currentAddress;
  }, {});
};

export default getCurrentRootAddress;
